// Module
var code = "<input id=\"{{name}}\" ng-model=\"ngModel\" ng-required=\"ngRequired\" ng-disabled=\"ngDisabled\" class=\"form-control\" focus-me=\"setFocus\" type=\"number\" max=\"{{max}}\" min=\"{{min}}\" step=\"{{step}}\"/> ";
// Exports
module.exports = code;